import { ContestPrize, CreateContestPrizeRequest, DeleteContestPrizeRequest, UpdateContestPrizeRequest } from "@beable/roster-backend-client-v1";
import RosterBackendService from "./RosterBackendService";

async function createContestPrize({ title, monetaryValue, points, imageUrl, displayNameEn, displayNameEs, isCustom }: ContestPrize) {
  const request = new  CreateContestPrizeRequest();
  request.title = title;
  request.monetaryValue = monetaryValue;
  request.points = points;
  request.imageUrl = imageUrl;
  request.displayNameEn = displayNameEn;
  request.displayNameEs = displayNameEs;
  request.isCustom = isCustom;
  
  const response = await RosterBackendService.createContestPrize(request);
  if (response.isOk()) {
      return response.value;
  }

  return null;
}

async function deleteContestPrize({ id }: ContestPrize) {
  const request = new DeleteContestPrizeRequest();
  request.id = id;
  
  const response = await RosterBackendService.deleteContestPrize(request);
  if (response.isOk()) {
      return response.value;
  }

  return null;
}

async function getAllContestPrizes() {
  const response = await RosterBackendService.getAllContestPrizes();
  if (response.isOk()) {
      return response.value;
  }

  return null;
}

async function saveContestPrize({ id, title, monetaryValue, points, imageUrl, displayNameEn, displayNameEs, isCustom }: ContestPrize) {
  const request = new  UpdateContestPrizeRequest();
  request.id = id;
  request.title = title;
  request.monetaryValue = monetaryValue;
  request.points = points;
  request.imageUrl = imageUrl;
  request.displayNameEn = displayNameEn;
  request.displayNameEs = displayNameEs;
  request.isCustom = isCustom;
  
  const response = await RosterBackendService.updateContestPrize(request);
  if (response.isOk()) {
      return response.value;
  }

  return null;
}

export default {
  createContestPrize,
  deleteContestPrize,
  getAllContestPrizes,
  saveContestPrize,
}